<template>
	<a-modal title="联系技术方" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
		<a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
			<!--可编辑区域 start-->
			<div class="hidden">
				<a-form-item label="achievementsId" name="achievementsId">
					<a-input v-model:value="form.achievementsId" />
				</a-form-item>
				<a-form-item label="receiveContact" name="receiveContact">
					<a-input v-model:value="form.receiveContact" />
				</a-form-item>
				<a-form-item label="receiveContactNumber" name="receiveContactNumber">
					<a-input v-model:value="form.receiveContactNumber" />
				</a-form-item>
			</div>
			<a-descriptions :column="2">
				<a-descriptions-item label="负责人">{{ form.principal }}</a-descriptions-item>
				<a-descriptions-item label="负责人电话">{{ form.principalPhone }}</a-descriptions-item>
			</a-descriptions>
			<a-form-item label="姓名" name="senderContact">
				<a-input v-model:value="form.senderContact" placeholder="请输入" />
			</a-form-item>
			<a-form-item label="联系电话" name="senderContactNumber">
				<a-input v-model:value="form.senderContactNumber" placeholder="请输入" />
			</a-form-item>
		</a-form>
	</a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { achievementFontInfo } from "@/api/achievementsService";

export default {
	name: "recruitmentModal",
	components: { },
	mixins: [formMixin],
	data() {
		return {
			form: {
				achievementsId: null,
			},
			rules: {
				senderContactNumber: [dataCheck.required({}), dataCheck.mobile_phone],
				senderContact: [dataCheck.required({})],
				receiveContact: [],
				receiveContactNumber: [],
				achievementsId: []
			},
			submitUrl: achievementFontInfo.saveOrUpdate
		}
	},
}
</script>
<style scoped lang="less"></style>
